<template>
    <div class="flex float-left vertical-center">
        <vs-switch :disabled="disabled" v-bind:id="'sld-status-'+no" v-model="statusValue" v-on:click="onClickAction">
            <span v-bind:id="'sld-status-on-'+no" slot="on">Active</span>
            <span v-bind:id="'sld-status-off-'+no" slot="off">Inactive</span>
        </vs-switch>
    </div>
</template>

<script>
    import Vue from "vue";

    export default Vue.extend({
        name: "ActiveInactiveAgGridComponent",
        data() {
            return {
                no: 0,
                statusValue: null,
                disabled:false
            }
        },
        methods: {
            onClickAction() {
                let payload = {
                    statusValue: !this.statusValue,
                    data: this.params.data
                }
                let root = this


                let statusString = (payload.statusValue) ? 'active' : 'inactive'
                this.$vs.dialog({
                    type: "confirm",
                    color: "primary",
                    title: `Confirm`,
                    text: `Set merchant status to ${statusString}?`,
                    accept: () => {
                        root.$root.$emit("status-from-ActiveInactiveAgGridComponent", payload)
                    },
                    cancel: () => {
                        this.statusValue = !this.statusValue
                    }
                })
            },
            refresh(params) {
                console.log(params)
                if (params.value !== this.params.value) {
                    this.params = params;
                    this.statusValue = (this.params.value === 'active') ? true : false
                }
                return true;
            },
        },
        mounted() {
            this.no = this.params.data.no
            this.statusValue = (this.params.value === 'active') ? true : false

            const role = localStorage.getItem("userRole")
            const merchant = JSON.parse(localStorage.getItem("userInfo")).merchant
            if (!(role == 'root' || role == 'administrator' || role == 'aino_cc' || role == 'merchant_admin') ) {
                this.disabled=true
            } else {
                if ((merchant.id !== undefined && merchant.id !== this.params.value) && parseInt(this.params.data.depth) <= parseInt(merchant.depth)) this.disabled = true;
            }
        }
    })
</script>

<style scoped>
    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
</style>